// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scenario-chip i {\n  margin-right: -0.2em !important;\n}\n.font {\n  color: red;\n  margin: 0 0 20px 10px;\n  font-size: 14px;\n  font-weight: bolder;\n}\n.font2 {\n  width: 500px;\n  color: red;\n  margin: 0 0 5px 7px;\n  font-size: 14px;\n  font-weight: bolder;\n}\n.font3 {\n  color: red;\n  margin: 0 0 20px 10px;\n  font-size: 14px;\n  font-weight: bolder;\n}\n.font4 {\n  color: red;\n  margin: 0 0 5px 7px;\n  font-size: 14px;\n  font-weight: bolder;\n}", ""]);
// Exports
module.exports = exports;
